import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ContentService } from "../../services/content.service";

@Component({
  selector: "app-appointment-modal",
  templateUrl: "./appointment-modal.component.html",
  styleUrl: "./appointment-modal.component.scss",
})
export class AppointmentModalComponent {
  @Input() appointment: any;
  @Input() section: any;
  @Input() mode: string = "add";
  appointmentForm: FormGroup;

  isSaving: boolean = false; // To track the saving state
  successMessage: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private contentService: ContentService
  ) {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // Formats YYYY-MM-DD
    const defaultTime = "09:00";

    this.appointmentForm = this.fb.group({
      date: [formattedDate, Validators.required],
      time: [defaultTime, Validators.required],
      location: ["", Validators.required],
      notes: [""],
    });
  }

  saveAppointment() {
    if (this.appointmentForm.invalid) {
      return;
    }

    this.isSaving = true;
    const updatedAppointment = {
      ...this.appointmentForm.value,
      sectionId: this.section.sectionId,
      userId: this.section.userId,
    };

    const saveObservable = this.appointment?.appointmentId
      ? this.contentService.saveAppointment(
          updatedAppointment,
          this.appointment.appointmentId
        )
      : this.contentService.saveAppointment(updatedAppointment);

    saveObservable.subscribe({
      next: (response) => {
        this.successMessage = "Appointment saved successfully!";
        this.isSaving = false; // Hide spinner

        // Close the modal after a delay
        setTimeout(() => {
          this.activeModal.close(response);
        }, 1000);
      },
      error: (error) => {
        console.error("Error saving appointment:", error);
        this.isSaving = false; // Hide spinner
      },
    });
  }
}
